import { WithEditor } from "@grapesjs/react";
import { Button } from "@mui/material";
import * as React from "react";
import {
    MdDataSaverOn as MdDataSaverOnIcon,
    MdOutlineDataSaverOff as MdOutlineDataSaverOffIcon,
    MdOutlinePublish as MdOutlinePublishIcon,
    MdSaveAlt as MdSaveAltIcon,
} from "react-icons/md";
import { ExtraEditorProps } from "../../../pages/CustomPages/CustomPage";
import { cx } from "./common";
import TopbarButtons from "./TopbarButtons";

const MdDataSaverOn = MdDataSaverOnIcon as React.ElementType;
const MdOutlineDataSaverOff = MdOutlineDataSaverOffIcon as React.ElementType;
const MdOutlinePublish = MdOutlinePublishIcon as React.ElementType;
const MdSaveAlt = MdSaveAltIcon as React.ElementType;

export default function Topbar({
    className,
    publishPage,
    saveThemeGlobal,
    updateThemeInfo,
    addProducts,
    page,
    exportJson,
}: React.HTMLAttributes<HTMLDivElement> & ExtraEditorProps) {
    console.log("Topbar", {
        publishPage,
        saveThemeGlobal,
        updateThemeInfo,
        addProducts,
        page,
        exportJson,
    });
    return (
        <div
            className={cx(
                "gjs-top-sidebar flex items-center p-1 gap-3 pl-2",
                className
            )}
        >
            <div className="flex-grow flex gap-4 justify-center">
                <WithEditor>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<MdOutlinePublish />}
                        onClick={publishPage}
                    >
                        Publish {updateThemeInfo ? " Theme" : ""}
                    </Button>
                </WithEditor>
                {addProducts && (
                    <WithEditor>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<MdSaveAlt />}
                            onClick={addProducts}
                        >
                            Add Products ({page?.products?.length || 0})
                        </Button>
                    </WithEditor>
                )}
                {saveThemeGlobal && !updateThemeInfo && (
                    <WithEditor>
                        <Button
                            variant="text"
                            color="info"
                            startIcon={<MdDataSaverOn />}
                            onClick={saveThemeGlobal}
                        >
                            {saveThemeGlobal.prototype?.buttonText ||
                                "Save Theme"}
                        </Button>
                    </WithEditor>
                )}

                {updateThemeInfo && (
                    <WithEditor>
                        <Button
                            variant="text"
                            color="info"
                            startIcon={<MdOutlineDataSaverOff />}
                            onClick={updateThemeInfo}
                        >
                            Change Theme Info
                        </Button>
                    </WithEditor>
                )}
            </div>
            <WithEditor>
                <TopbarButtons className="ml-auto px-2" />
            </WithEditor>
        </div>
    );
}
